export default "__VITE_ASSET__2tz3isbA__"